<template>
    <div class="filter-item filter-item--keywords" v-if="keywords.length">
        <h2 class="filter-item__heading" v-text="translations.title"></h2>
        <div class="filter-item__keywords">
            <div class="keyword-item" v-for="(keyWord, keyWordKey) in keywords" :key="keyWordKey" @click="selectKeyword(keyWord)" :class="{'keyword-item--active': isActive(keyWord) || noItemsSelected}"><span v-text="keyWord.name"></span></div>
        </div>
        <button class="btn-expand" @click="showNonStarred = !showNonStarred" :class="{'show-all': showNonStarred}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </button>
    </div>
</template>

<script>
import _ from 'underscore';
import { trackEvent } from '../../tracker';

export default {
    props: {
        excludedKeywords: {type: Array, default: null}
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.KEYWORD_FILTER,
            activeKeywords: [ ],
            showNonStarred: false
        }
    },
    mounted() {
        this.parseRouteKeywords();        
    },
    watch: {
        '$route.query.keywords'() {
            this.parseRouteKeywords();
        },
        showNonStarred() {
            this.$emit('keywordchange');
        },
        activeKeywords(newVal) {
            if(_.isEmpty(newVal)) {
                newVal = null;
            }

            let query = Object.assign({}, this.$route.query);
            query.keywords = (newVal) ? JSON.stringify(newVal) : newVal;
            this.$router.replace({query}, (to, from, next) => {
                    let value = this.keywords.filter((keyword) => this.isActive(keyword));
                    trackEvent({
                        event: 'Filter - ' + this.translations.title,
                        target: to.fullPath,
                        value,
                        destination: (this.$store) ? this.$store.state.destination : null,
                        'interaction-type': 'noninteraction',
                    })
                });
        }
    },
    methods: {
        parseRouteKeywords() {
            try {
                this.activeKeywords = (this.$route.query.keywords) ? JSON.parse(this.$route.query.keywords) : [ ];
            } catch(e) {

            }
        },
        selectKeyword(keyword) {
            let key = this.activeKeywords.indexOf(keyword.code);
            if(key > -1) {
                this.activeKeywords.splice(key, 1);
            } else {
                this.activeKeywords.push(keyword.code);
            }
        },
        isActive(keyword) {
            return (this.activeKeywords.indexOf(keyword.code) > -1); 
        }
    },
    computed: {
        noItemsSelected() {
            let activeKeywordList = this.activeKeywords.filter((code) => this.excludedKeywords.indexOf(code) <= -1);
            return _.isEmpty(activeKeywordList);
        },
        foldTxt() {
            return (!this.showNonStarred) ? this.translations.fold_out_txt : this.translations.fold_in_txt;
        },
        keywords() {
            let keyWords = this.$store.state.filters.keywords || [ ];
            if(this.excludedKeywords) {
                keyWords = keyWords.filter(keyword => this.excludedKeywords.indexOf(keyword.code) <= -1);
            }

            let starredKeywords = keyWords.filter(keyword => keyword.starred);
            let nonStarredKeywords = keyWords.filter(keyword => !keyword.starred);

            return (this.showNonStarred) ? starredKeywords.concat(nonStarredKeywords) : starredKeywords;
        },
    }
}
</script>
